import { Tag } from 'lucide-react';
import type { Offer } from '../types.js';

export function promotionText(offer: Pick<Offer, 'promoCode' | 'discountType' | 'discountValue' | 'currency'>) {
  const code = offer.promoCode?.trim();
  const value = Number(offer.discountValue);
  if (!code || !offer.discountType || !Number.isFinite(value) || value <= 0) return null;
  if (offer.discountType === 'PERCENTAGE') {
    if (value > 100) return null;
    return { code, discount: new Intl.NumberFormat('en-GB', { maximumFractionDigits: 2 }).format(value) + '%' };
  }
  if (!offer.currency) return null;
  try {
    return {
      code,
      discount: new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: offer.currency,
        maximumFractionDigits: 2,
      }).format(value),
    };
  } catch {
    return null;
  }
}

export function OfferPromotion({ offer }: { offer: Pick<Offer, 'promoCode' | 'discountType' | 'discountValue' | 'currency'> }) {
  const promotion = promotionText(offer);
  return promotion ? (
    <p className="offer-promotion">
      <Tag size={14} strokeWidth={2.2} aria-hidden="true" />
      <span>Use <strong>{promotion.code}</strong> for <strong>{promotion.discount} off</strong></span>
    </p>
  ) : null;
}
